import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useDispatch } from "react-redux";
import { callGetSpecialAgentCommision, callDeleteSpecialAgentCommision } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { encodeBase64, handleGetCookie } from "../../../utils/commonUtil";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter";
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import Swal from "sweetalert2";
import colors from '../../../utils/colors';
import moment from "moment";
import statusItems from "../../../data/agentSpecial"
import { useLocation, useNavigate } from 'react-router-dom';
import SmartTable from "../../../components/common/table-component";

const SpecialAgentCommision = () => {
	let baseUrl = "/admin/setting/agentSpecialCommision/save";
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', updateBy: '', status: '', });
	const [specialAgentList, setSpecialAgentList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const location = useLocation();

	useEffect(() => {
		if (location.state?.refresh) {
			loadData();
		}
	}, [location.state]);

	useEffect(() => {
		loadData();
		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				updateBy: authData?.user?.userId,
				updateName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { page: request.page, maxResult: request.maxResult, keyword: request.keyword, status: request.status };
		const rsp = await dispatch(callGetSpecialAgentCommision(data));
		console.log(rsp.payload)
		if (rsp?.payload?.responseCode === "00000") {
			setSpecialAgentList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords);
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault();
		loadData();
	};

	const handleEdit = (id) => {
		navigate(baseUrl + "/" + encodeBase64(id));
	};

	const handleDelete = (id) => {
		Swal.fire({
			title: t("titleDelete"),
			text: t("confirmDelete"),
			icon: "warning",
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				const rsp = await dispatch(callDeleteSpecialAgentCommision({ id, updateBy: request.updateBy }));
				if (rsp?.payload?.responseCode === "00000") {
					Swal.fire({
						icon: "success",
						title: t("success.delete"),
						confirmButtonColor: colors.confirmMessage,
						confirmButtonText: t('close'),
					}).then(() => {
						loadData();
					});
				}
			}
		});
	};

	const selectStatus = (e) => {
		setRequest((prev) => ({
			...prev,
			status: e.target.value,
		}));
	}

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.setting.commissionAgent")}</h4>

						<div className="group-button-header">
							<button type="button" className="btn btn-primary" onClick={() => navigate(baseUrl)}>
								<i className="fas fa-plus"></i> {t("button.add")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
														/>
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('status.text')}</label>
													<select className="chosen-single form-select"
														onChange={selectStatus}
														value={request.status}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															statusItems.map((item) => (
																<option key={item.id} value={item.key}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "settings.agentSpecialCommission.id", key: "id" },
							{ labelKey: "settings.agentSpecialCommission.agentCode", key: "agentCode" },
							{ labelKey: "settings.agentSpecialCommission.firstName", key: "firstName" },
							{ labelKey: "settings.agentSpecialCommission.lastName", key: "lastName" },
							{ labelKey: "settings.agentSpecialCommission.commission", key: "commissionRate" },
							{ labelKey: "settings.agentSpecialCommission.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.active')}</span> : val === 0 ? <span className="badge bg-primary">{t('status.waiting')}</span> : <span className="badge bg-danger">{t('status.rejected')}</span> },
							{ labelKey: "settings.agentSpecialCommission.createdDate", key: "createdAt", render: (val) => val ? moment(val).format("DD/MM/YYYY HH:mm:ss") : '-' },
							{ labelKey: "settings.agentSpecialCommission.createdBy", key: "createdBy" },
						]}
	data={{ result: specialAgentList }}
	rowKey="id"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={false}
	actions={(item) => (<div>
							{item.status === 0 && <button className="btn btn-primary btn-sm" onClick={() => handleEdit(item.id)}><i className="fas fa-pen"></i></button>}
							&nbsp;
							{item.status === 0 && <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.id)}><i className="fas fa-trash"></i></button>}
						</div>)}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default SpecialAgentCommision;
